export default {
  path: '/products',
  component: () => import('../../views/admin/products/index'),
  children: [
    {
      path: '',
      component: () => import('../../views/admin/products/index'),
      children: [
        {
          path: '',
          name: 'ProductsList',
          component: () => import(/* webpackChunkName: "ProductsList" */ '../../views/admin/products/list/productsList.vue'),
          meta: {
            pageTitle: 'لیست کالا و خدمت',
            pageTitleI18n: 'products.list.title',
            permission: 'product.show'
            // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'ProductsTrash',
          component: () => import(/* webpackChunkName: "ProductsTrash" */ '../../views/admin/products/trash/productsTrash.vue'),
          meta: {
            pageTitle: 'سطل آشغال کالا و خدمت',
            pageTitleI18n: 'products.trash.title',
            permission: 'product.delete'
            // rule: 'editor'
          }
        },
        {
          path: 'prd-:id',
          component: () => import('../../views/admin/products/product/index.vue'),
          children: [
            {
              path: '/',
              name: 'Product',
              component: () => import(/* webpackChunkName: "Product" */ '../../views/admin/products/product/menu/productMenu.vue'),
              meta: {
                pageTitle: 'کالا',
                pageTitleI18n: 'products.product.title',
                layoutStatus: 'profile',
                permission: 'product.show'
                // rule: 'editor'
              }
            },
            {
              path: 'languages',
              name: 'productLanguages',
              component: () => import(/* webpackChunkName: "productLanguages" */ '../../views/admin/products/product/languages/list/productLanguagesList.vue'),
              meta: {
                pageTitle: 'شخصی سازی کالا',
                pageTitleI18n: 'products.product.languages.title',
                layoutStatus: 'profile',
                permission: 'product_language.show'
                // rule: 'editor'
              }
            },
            {
              path: 'modules',
              name: 'modules',
              component: () => import(/* webpackChunkName: "modules" */ '../../views/admin/products/product/modules/list/moduleList.vue'),
              meta: {
                permission: 'module.show',
                pageTitle: 'ماژول ها',
                pageTitleI18n: 'modules.list.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'setting',
              name: 'productProfileSetting',
              component: () => import(/* webpackChunkName: "productProfileSetting" */ '../../views/admin/products/product/setting/productSetting.vue'),
              meta: {
                permission: 'product.update',
                pageTitle: 'ماژول ها',
                pageTitleI18n: 'products.product.setting.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'addons',
              component: () => import('../../views/admin/products/product/addons/index.vue'),
              children: [
                {
                  path: '',
                  name: 'addons',
                  component: () => import(/* webpackChunkName: "addons" */ '../../views/admin/products/product/addons/list/addonList.vue'),
                  meta: {
                    permission: 'addon.show',
                    pageTitle: 'افزودنی ها',
                    pageTitleI18n: 'addons.list.title',
                    layoutStatus: 'profile'
                    // rule: 'editor'
                  }
                },
                {
                  path: 'trash',
                  name: 'addonsTrash',
                  component: () => import(/* webpackChunkName: "addonsTrash" */ '../../views/admin/products/product/addons/trash/addonTrash.vue'),
                  meta: {
                    permission: 'addon.delete',
                    pageTitle: 'سطل زباله افزودنی ها',
                    pageTitleI18n: 'addons.trash.title',
                    layoutStatus: 'profile'
                    // rule: 'editor'
                  }
                },
              ]
            },
            {
              path: 'activities-log',
              name: 'ProductActivitiesLog',
              component: () => import(/* webpackChunkName: "userActivitiesLog" */ '../../views/admin/products/product/activitiesLog/productActivitiesLog.vue'),
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های کالا',
                pageTitleI18n: 'products.product.logs.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'EditProduct',
              component: () => import(/* webpackChunkName: "EditProduct" */ '../../views/admin/products/edit/editProduct.vue'),
              meta: {
                pageTitle: 'ویرایش کالا',
                pageTitleI18n: 'products.edit.title',
                layoutStatus: 'profile',
                // permission: 'product.update'
                // rule: 'editor'
              }
            }
          ]
        },
        {
          path: 'prd-:id/languages/:lang',
          component: () => import('../../views/admin/products/product/languages/language/editKeys/index.vue'),
          children: [
            {
              path: '',
              name: 'editProductKeyLanguage',
              component: () => import(/* webpackChunkName: "editProductLanguage" */ '../../views/admin/products/product/languages/language/editKeys/editLanguageKeys.vue'),
              meta: {
                pageTitle: '',
                pageTitleI18n: 'products.product.languages.edit.title',
                permission: 'product_language.update',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editProductLanguage',
              component: () => import(/* webpackChunkName: "editProductLanguage" */ '../../views/admin/products/product/languages/language/edit/editLanguage.vue'),
              meta: {
                pageTitle: '',
                pageTitleI18n: 'products.product.languages.edit.title',
                permission: 'product_language.update',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: ':subject',
              name: 'editProductLanguageSubject',
              component: () => import(/* webpackChunkName: "editProductLanguageSubject" */ '../../views/admin/products/product/languages/language/editKeys/editLanguageKeys.vue'),
              meta: {
                pageTitle: '',
                pageTitleI18n: 'products.product.languages.edit.title',
                permission: 'product_language.update',
                // layoutStatus: 'profile'
                // rule: 'editor'
              }
            }
          ]
        },
        {
          path: 'prd-:id/modules/:moduleId',
          component: () => import('../../views/admin/products/product/modules/module/index.vue'),
          children: [
            {
              path: '',
              component: () => import(/* webpackChunkName: "addon" */ '../../views/admin/products/product/modules/module/profile/moduleProfile.vue'),
              name: 'module',
              meta: {
                permission: 'module.show',
                pageTitle: 'ماژول',
                pageTitleI18n: 'modules.profile.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'edit',
              component: () => import(/* webpackChunkName: "editModule" */ '../../views/admin/products/product/modules/edit/editModule.vue'),
              name: 'editModule',
              meta: {
                permission: 'module.update',
                pageTitle: 'ویرایش ماژول',
                pageTitleI18n: 'modules.edit.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'moduleActivitiesLog',
              component: () => import(/* webpackChunkName: "moduleActivitiesLog" */ '../../views/admin/products/product/modules/module/activitiesLog/moduleActivitiesLog.vue'),
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های ماژول',
                pageTitleI18n: 'modules.logs.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            }
          ]
        },
        {
          path: 'prd-:id/addons/:addonId',
          component: () => import('../../views/admin/products/product/addons/addon/index.vue'),
          children: [
            {
              path: '',
              component: () => import(/* webpackChunkName: "addon" */ '../../views/admin/products/product/addons/addon/profile/addonProfile.vue'),
              name: 'addon',
              meta: {
                permission: 'addon.show',
                pageTitle: 'افزودنی',
                pageTitleI18n: 'addons.profile.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'edit',
              component: () => import(/* webpackChunkName: "editAddon" */ '../../views/admin/products/product/addons/edit/editAddon.vue'),
              name: 'editAddon',
              meta: {
                permission: 'addon.update',
                pageTitle: 'ویرایش افزودنی',
                pageTitleI18n: 'addons.edit.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'apps',
              component: () => import(/* webpackChunkName: "addonApps" */ '../../views/admin/products/product/addons/addon/apps/addonApps.vue'),
              name: 'addonApps',
              meta: {
                permission: 'sale_plan.update',
                pageTitle: 'باشگاه های پلن فروش',
                pageTitleI18n: 'addons.apps.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'addonActivitiesLog',
              component: () => import(/* webpackChunkName: "addonActivitiesLog" */ '../../views/admin/products/product/addons/addon/activitiesLog/addonActivitiesLog.vue'),
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های افزودنی',
                pageTitleI18n: 'addons.logs.title',
                layoutStatus: 'profile'
                // rule: 'editor'
              }
            }
          ]
        },
        /*{
          path: 'insert',
          name: 'InsertProduct',
          component: () => import(/!* webpackChunkName: "InsertProduct" *!/ '../../views/admin/products/products/insert/insertProduct.vue'),
          meta: {
            pageTitle: 'افزودن کالا',
            pageTitleI18n: 'products.insert.title'
            // rule: 'editor'
          }
        }*/
      ]
    }
  ]
}
